import { createSelector } from 'reselect';

import type { State } from 'reducers';

import type VolunteerTime from './model';

const sortVolunteerTimes = (a: VolunteerTime, b: VolunteerTime) => {
  if (a.createdAt < b.createdAt) {
    return -1;
  } else if (a.createdAt > b.createdAt) {
    return 1;
  }

  return 0;
};

export const selectVolunteerTimeState = (state: State) => state.get('entities').volunteerTime;

export const selectVolunteerTimes = createSelector(selectVolunteerTimeState, (volunteerTimeState) =>
  volunteerTimeState.get('volunteerTimes')
);

export const selectVolunteerTimesByDeed = createSelector(
  selectVolunteerTimes,
  (_state, deedId: string) => deedId,
  (volunteerTimes, deedId) =>
    volunteerTimes
      .filter((volunteerTime) => volunteerTime?.deed?.id === deedId)
      .sort(sortVolunteerTimes)
);

export const selectVolunteerTimesByUser = createSelector(
  selectVolunteerTimes,
  (_state, userId: string) => userId,
  (volunteerTimes, userId) =>
    volunteerTimes
      .filter((volunteerTime) => volunteerTime?.user?.id === userId)
      .sort(sortVolunteerTimes)
);

export const selectVolunteerTimeById = createSelector(
  selectVolunteerTimes,
  (_state, id: string): string => id,
  (volunteerTimes, id) => volunteerTimes.get(id)
);
